// TanStack Query client config.
//
// We use Query for two things in this app:
//   1. Caching one-shot Firestore reads (where the doc isn't likely to change
//      within the session, e.g. the user profile).
//   2. Wrapping callable Cloud Function invocations (with retry + state).
//
// For data that needs live updates (events feed, my tickets), prefer
// Firestore's onSnapshot directly — Query's cache and Firestore's listener
// don't compose well.

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Conservative defaults — internal app, low traffic, fresh-ish data is fine.
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        // Don't retry on permission-denied or unauthenticated — those won't recover.
        const code = (error as { code?: string } | undefined)?.code ?? '';
        if (code.includes('permission-denied') || code.includes('unauthenticated')) {
          return false;
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
